/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import "./index.css";
import axios from "axios";
import config from "../../config";
import { trackPartnerPageView } from "../../utils/metaPixel";
import FooterComponent from "../../components/FooterComponent";
import TnCDialog from "./TnCDialog";
import JoyRides from "./JoyRides";
import { Tabs } from "antd";
import Shuttle from "./Shuttle";
import { withRouter } from "react-router-dom";

const ShuttleIcon = ({ size = 24, color = "#e2b148" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9513 1C15.4533 1 15.041 1.35246 14.9086 1.85263H14.9085C14.5506 3.22193 13.3833 4.36152 11.998 4.36976C10.5972 4.36976 9.41428 3.35315 9.07972 1.87737C8.96299 1.36071 8.53498 1 8.03697 1H6.07579C5.48453 1 5.00195 1.50819 5.00195 2.13134V6.95224C5.00195 7.11622 5.1265 7.2392 5.27433 7.2392L18.7218 7.2392C18.8774 7.2392 18.9941 7.10798 18.9941 6.95224V2.13134C18.9941 1.50842 18.5118 1 17.9203 1H15.9513ZM19.0019 21.8686L19.0019 8.97985C19.0019 8.82411 18.8773 8.69271 18.7295 8.69271L5.29003 8.69289C5.13438 8.69289 5.01765 8.82411 5.01765 8.97985L5.01765 21.8686C5.01765 22.4916 5.50001 23 6.09149 23H17.9203C18.5195 23 19.0019 22.4916 19.0019 21.8686ZM11.2198 14.4406V11.5545L11.8813 11.5543C12.1304 11.5543 12.3406 11.7265 12.4028 11.9807L12.9865 14.4486H14.6829C15.1109 14.4486 15.5078 14.7603 15.5778 15.203C15.6635 15.7686 15.2511 16.2606 14.7296 16.2606H12.9786L12.395 18.7285C12.3326 18.9744 12.1226 19.1549 11.8735 19.1549H11.2198L11.22 16.2606H9.64794L9.44557 17.097C9.38318 17.3429 9.17318 17.5234 8.92408 17.5234H8.41825L8.41808 13.1778H8.92391C9.17303 13.1778 9.38321 13.35 9.4454 13.6042L9.64777 14.4406H11.2198Z"
        fill={color}
      />
    </svg>
  );
};

const JoyRideIcon = ({ size = 24, color = "#e2b148" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8216 22.2977L19.1334 13.7031C18.8613 13.8152 18.5659 13.8863 18.2561 13.9075C17.493 13.96 16.7285 13.7116 16.1787 13.1724C15.7909 13.5448 15.2721 13.7916 14.6936 13.8692C14.1648 13.9397 13.6438 13.8639 13.1836 13.6613L9.44603 22.3697C9.38762 22.5093 9.40096 22.6713 9.48654 22.7974C9.56772 22.9235 9.71171 23 9.86025 23H22.4392H22.4482C22.6958 23 22.8983 22.7974 22.8983 22.5498C22.8983 22.4551 22.8713 22.3697 22.8219 22.2976L22.8216 22.2977Z"
        fill={color}
      />
      <path
        d="M14.5736 12.9771C15.089 12.9079 15.5255 12.6463 15.7717 12.2595C15.8455 12.1435 15.9683 12.0677 16.1049 12.0534C16.4346 12.0202 16.5446 12.2994 16.7907 12.5115C17.1381 12.8645 17.6534 13.0479 18.1945 13.0093C18.4024 12.9952 18.5952 12.9419 18.7753 12.8691L16.564 7.71539C16.4919 7.54879 16.3299 7.44531 16.1498 7.44531C15.9697 7.44531 15.8076 7.54879 15.7355 7.71539L13.5427 12.8245C13.8563 12.9633 14.2134 13.0244 14.5736 12.9771L14.5736 12.9771Z"
        fill={color}
      />
      <path
        d="M6.36615 15.0006C6.80048 14.9166 7.15486 14.6886 7.36369 14.3592C7.43749 14.2427 7.56059 14.1664 7.69783 14.1524C7.83412 14.1376 7.97089 14.1876 8.06714 14.2866L8.36485 14.5935C8.86213 15.0936 9.70708 15.1926 10.3377 14.8554L8.04154 11.1322C7.95597 10.9927 7.80303 10.9071 7.64538 10.9162C7.48318 10.9207 7.33479 11.0107 7.26272 11.1549L5.28992 14.8756C5.61542 15.0232 5.99823 15.0725 6.36612 15.0006L6.36615 15.0006Z"
        fill={color}
      />
      <path
        d="M11.1343 16.1478L10.8099 15.6216C10.4189 15.8422 9.97956 15.9573 9.53864 15.9573C8.8911 15.9573 8.2465 15.7243 7.76947 15.2705C7.44193 15.5789 7.01891 15.7917 6.53751 15.8849C5.96059 15.997 5.37287 15.9174 4.86711 15.6729L1.3332 22.3381C1.25673 22.4777 1.26128 22.6443 1.3467 22.7793C1.42772 22.9144 1.57187 22.9954 1.72936 22.9954H8.58582C8.47795 22.6892 8.48234 22.3381 8.61283 22.023L11.1343 16.1478Z"
        fill={color}
      />
      <path
        d="M13.7271 6.06003C13.7271 6.3086 13.9284 6.5102 14.1772 6.5102H14.7967C15.0455 6.5102 15.2468 6.30859 15.2468 6.06003C15.2468 5.81148 15.0455 5.60986 14.7967 5.60986H14.1772C13.9285 5.60986 13.7271 5.81148 13.7271 6.06003Z"
        fill={color}
      />
      <path
        d="M13.1382 6.05986C13.1382 7.46926 12.0018 8.61191 10.5999 8.61191C9.19802 8.61191 8.06165 7.46926 8.06165 6.05986C8.06165 4.6503 9.19802 3.50781 10.5999 3.50781C12.0018 3.50781 13.1382 4.6503 13.1382 6.05986Z"
        fill={color}
      />
      <path
        d="M10.5997 2.91273C10.8486 2.91273 11.0499 2.71111 11.0499 2.46256V1.83982C11.0499 1.59125 10.8486 1.38965 10.5997 1.38965C10.3508 1.38965 10.1495 1.59126 10.1495 1.83982V2.46256C10.1495 2.71112 10.3508 2.91273 10.5997 2.91273Z"
        fill={color}
      />
      <path
        d="M13.4489 3.834L13.8868 3.3934C14.0622 3.21707 14.0615 2.93194 13.8851 2.75684C13.7088 2.58144 13.4239 2.5827 13.2486 2.75856L12.8106 3.19917C12.6352 3.3755 12.636 3.66063 12.8123 3.83573C12.989 4.01144 13.2738 4.00987 13.4489 3.834Z"
        fill={color}
      />
      <path
        d="M13.8866 8.72605L13.4486 8.28577C13.2733 8.10897 12.9883 8.10865 12.8121 8.28404C12.6357 8.45928 12.635 8.74442 12.8104 8.92061L13.2483 9.36089C13.422 9.53581 13.7068 9.53942 13.8849 9.36262C14.061 9.18738 14.062 8.90224 13.8866 8.72605Z"
        fill={color}
      />
      <path
        d="M10.1499 9.65671V10.2798C10.1499 10.5283 10.3512 10.7299 10.6001 10.7299C10.8489 10.7299 11.0502 10.5283 11.0502 10.2798V9.65671C11.0502 9.40815 10.8489 9.20654 10.6001 9.20654C10.3512 9.20654 10.1499 9.408 10.1499 9.65671Z"
        fill={color}
      />
      <path
        d="M7.75087 8.28554L7.31292 8.72582C7.13753 8.90215 7.13831 9.18728 7.31465 9.36238C7.49051 9.53746 7.77583 9.5373 7.95121 9.36065L8.38916 8.92037C8.56456 8.74404 8.56377 8.45891 8.38744 8.28381C8.2111 8.10842 7.92625 8.10936 7.75087 8.28554Z"
        fill={color}
      />
      <path
        d="M6.40232 6.50972H7.02224C7.27112 6.50972 7.47241 6.3081 7.47241 6.05955C7.47241 5.81099 7.27111 5.60938 7.02224 5.60938H6.40232C6.15344 5.60938 5.95215 5.81099 5.95215 6.05955C5.95215 6.3081 6.15345 6.50972 6.40232 6.50972Z"
        fill={color}
      />
      <path
        d="M7.75087 3.83405C7.925 4.00944 8.21032 4.01211 8.38743 3.83577C8.56377 3.66054 8.56455 3.37539 8.38916 3.19921L7.95121 2.7586C7.77582 2.5818 7.49083 2.58101 7.31465 2.75688C7.13831 2.93211 7.13753 3.21726 7.31292 3.39344L7.75087 3.83405Z"
        fill={color}
      />
    </svg>
  );
};

const BookWithUsComponent = (props) => {
  const [rcsShuttles, setRcsShuttles] = useState([]);
  const [badrinathShuttles, setBadrinathShuttles] = useState([]);
  const [keralaJoyRides, setKeralaJoyRides] = useState([]);
  const [tumakurJoyRides, setTumakurJoyRides] = useState([]);
  // const [testShuttles, setTestShuttles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [termsnConditions, setTermsnConditions] = useState([]);

  const [selectedTab, setSelectedTab] = useState("");
  const keralaPageViewTracked = useRef(false);

  // The Kerala by Air partner pixel only tracks Kerala surfaces, so PageView is
  // fired here (once per visit) rather than from App.js, which is site-wide.
  useEffect(() => {
    if (selectedTab === "kerala-joyride" && !keralaPageViewTracked.current) {
      keralaPageViewTracked.current = true;
      trackPartnerPageView("bookwithus:kerala-joyride");
    }
  }, [selectedTab]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(config.baseUrl + "v2/schedules", {
        headers: {
          "x-helitaxii-client": "browser",
        },
      })
      .then((res) => {
        const rcsShuttleSchedules = res.data.schedules.filter(
          (s) => s.type === "shuttle" && s.program === "UACS"
        );
        const badrinathShuttleSchedules = res.data.schedules.filter(
          (s) => s.type === "shuttle" && s.program === "BADRINATH"
        );
        // const testShuttleSchedules = res.data.schedules.filter(
        //   (s) => s.type === "shuttle" && s.program === "TEST"
        // );
        const keralaJoyRideSchedules = res.data.schedules.filter(
          (s) => s.type === "joyRide" && s.program === "KERALA_BY_SKY"
        );
        const tumakurJoyRideSchedules = res.data.schedules.filter(
          (s) => s.type === "joyRide" && s.program === "TUMAKUR_DASARA_2026"
        );
        setRcsShuttles(rcsShuttleSchedules);
        setBadrinathShuttles(badrinathShuttleSchedules);
        setKeralaJoyRides(keralaJoyRideSchedules);
        setTumakurJoyRides(tumakurJoyRideSchedules);
        // setTestShuttles(testShuttleSchedules);

        const params = new URLSearchParams(props.location.search);
        const currentTab = params.get("tab");

        let tabKey = null;
        if (currentTab === "UACS") {
          tabKey = "rcs-shuttle";
        } else if (currentTab === "BADRINATH") {
          tabKey = "badrinath-shuttle";
        } else if (currentTab === "KERALA-JOYRIDE") {
          tabKey = "kerala-joyride";
        } else if (currentTab === "TUMAKUR-DASARA-2026") {
          tabKey = "tumakur-joyride";
        // } else if (currentTab === "TEST") {
        //   tabKey = "test-shuttle";
        }

        const tabHasData = {
          "rcs-shuttle": rcsShuttleSchedules.length > 0,
          "badrinath-shuttle": badrinathShuttleSchedules.length > 0,
          "kerala-joyride": keralaJoyRideSchedules.length > 0,
          "tumakur-joyride": tumakurJoyRideSchedules.length > 0,
          // "test-shuttle": testShuttleSchedules.length > 0,
        };

        const defaultTab = tabHasData["rcs-shuttle"]
          ? "rcs-shuttle"
          : tabHasData["badrinath-shuttle"]
          ? "badrinath-shuttle"
          : tabHasData["kerala-joyride"]
          ? "kerala-joyride"
          : tabHasData["tumakur-joyride"]
          ? "tumakur-joyride"
          // : tabHasData["test-shuttle"]
          // ? "test-shuttle"
          : "";

        setSelectedTab(tabKey && tabHasData[tabKey] ? tabKey : defaultTab);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.location.search]);

  return (
    <section
      id="joy-ride-page"
      style={{
        paddingTop: "60px",
        minHeight: "100vh",
      }}
    >
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "#00529955",
            zIndex: 301,
            opacity: 0.75,
            display: loading ? "block" : "none",
          }}
        >
          <div className="lds-roller">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <TnCDialog
        termsnConditions={termsnConditions}
        onClose={() => setTermsnConditions([])}
      />

      <div className="banner joride" style={{ height: "400px" }}>
        <h1
          style={{
            margin: 0,
            textAlign: "center",
            fontSize: "50px",
            fontWeight: 600,
            color: "white",
            display: "flex",
            justifyContent: "center",
            height: "100%",
            width: "100%",
            fontFamily: "Open Sans",
            position: "relative",
            zIndex: 1,
            paddingTop: "100px",
          }}
        >
          Fly with Thumby Aviation
        </h1>
      </div>
      <div style={{ minHeight: "400px" }}>
        {rcsShuttles.length === 0 &&
          badrinathShuttles.length === 0 &&
          keralaJoyRides.length === 0 &&
          tumakurJoyRides.length === 0 &&
          // testShuttles.length === 0 &&
          !loading && (
            <div
              className="tabs-wrapper"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div>
                <h4>
                  We don&apos;t have any services available at the moment.
                  Please check back later.
                </h4>
              </div>
            </div>
          )}
        {(rcsShuttles.length > 0 ||
          badrinathShuttles.length > 0 ||
          keralaJoyRides.length > 0 ||
          tumakurJoyRides.length > 0 /* || testShuttles.length > 0 */) && (
          <div className="tabs-wrapper" style={{ padding: "20px" }}>
            <Tabs
              type="card"
              activeKey={selectedTab}
              onChange={(key) => setSelectedTab(key)}
              color="#e2b148"
              items={[
                ...(tumakurJoyRides.length > 0
                  ? [
                      {
                        label: "Tumakur By Sky - Dasara 2026",
                        key: "tumakur-joyride",
                        children: (
                          <JoyRides
                            setTermsnConditions={setTermsnConditions}
                            schedules={tumakurJoyRides}
                            setLoading={setLoading}
                            returnUrl="/bookwithus?tab=TUMAKUR-DASARA-2026"
                          />
                        ),
                      },
                    ]
                  : []),
                ...(rcsShuttles.length > 0
                  ? [
                      {
                        label: (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <ShuttleIcon
                              size={16}
                              color={
                                selectedTab === "rcs-shuttle"
                                  ? "#e2b148"
                                  : "#000"
                              }
                            />
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: 600,
                                marginLeft: "10px",
                              }}
                            >
                              Regional Connectivity Service
                            </span>
                          </div>
                        ),
                        key: "rcs-shuttle",
                        children: (
                          <Shuttle
                            schedules={rcsShuttles}
                            setTermsnConditions={setTermsnConditions}
                            setLoading={setLoading}
                          />
                        ),
                      },
                    ]
                  : []),
                ...(badrinathShuttles.length > 0
                  ? [
                      {
                        label: (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <ShuttleIcon
                              size={16}
                              color={
                                selectedTab === "badrinath-shuttle"
                                  ? "#e2b148"
                                  : "#000"
                              }
                            />
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: 600,
                                marginLeft: "10px",
                              }}
                            >
                              Badrinath Shuttle
                            </span>
                          </div>
                        ),
                        key: "badrinath-shuttle",
                        children: (
                          <Shuttle
                            schedules={badrinathShuttles}
                            setTermsnConditions={setTermsnConditions}
                            setLoading={setLoading}
                          />
                        ),
                      },
                    ]
                  : []),
                ...(keralaJoyRides.length > 0
                  ? [
                      {
                        label: (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <JoyRideIcon
                              size={16}
                              color={
                                selectedTab === "kerala-joyride"
                                  ? "#e2b148"
                                  : "#000"
                              }
                            />
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: 600,
                                marginLeft: "10px",
                              }}
                            >
                              Kerala By Sky
                            </span>
                          </div>
                        ),
                        key: "kerala-joyride",
                        children: (
                          <JoyRides
                            setTermsnConditions={setTermsnConditions}
                            schedules={keralaJoyRides}
                            setLoading={setLoading}
                          />
                        ),
                      },
                    ]
                  : []),
                // ...(testShuttles.length > 0
                //   ? [
                //       {
                //         label: (
                //           <div
                //             style={{ display: "flex", alignItems: "center" }}
                //           >
                //             <ShuttleIcon
                //               size={16}
                //               color={
                //                 selectedTab === "test-shuttle"
                //                   ? "#e2b148"
                //                   : "#000"
                //               }
                //             />
                //             <span
                //               style={{
                //                 fontSize: "14px",
                //                 fontWeight: 600,
                //                 marginLeft: "10px",
                //               }}
                //             >
                //               Test (Rs 1)
                //             </span>
                //           </div>
                //         ),
                //         key: "test-shuttle",
                //         children: (
                //           <Shuttle
                //             schedules={testShuttles}
                //             setTermsnConditions={setTermsnConditions}
                //             setLoading={setLoading}
                //           />
                //         ),
                //       },
                //     ]
                //   : []),
              ]}
            />
          </div>
        )}
      </div>
      <FooterComponent />
    </section>
  );
};

export default withRouter(BookWithUsComponent);
